import AES256 from "aes-everywhere";

export const decryptaValue = (value) => {
    const secretKey = "1234567890abcdef";
  
    const dencrypted = AES256.decrypt(value, secretKey);
  
    return dencrypted;
  }; // decryption